import * as $ from 'jquery';
import 'bootstrap';

export class searchContainer{
	$scope: any = $('#search-container');
	$searchIcon: any = $('.top-search--icon');
	$lastScrPos:number = 0;
	openSearchInput(): void {
		let _self = this;
		if(_self.$scope.length == 0) return
		_self.$scope.find('#search-input-header').on('click', () => {
			_self.$searchIcon.show();
		});
		_self.$scope.find('#search-input-header').blur(() => {
			_self.$searchIcon.hide();
		});
	}

	/**
	 * add event handler on mobile search field
	 * - on click, force scroll to top of page
	 *   where search bar is located
	 * @return {any} [description]
	 */
	initMobileSearchInput(): void {
		let _self = this;
		let $mobSearch = $('#mobile-search');
		let $mobileNav = $('.mobile-nav');

		$mobSearch.on('click', function () {
			if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				$mobileNav.parent().animate({
					'scrollTop': 900
				});
			}
		});
	}
}
let scope:Element = document.querySelector('#search-container');
if (scope){
	try {
		let searchcontainer = new searchContainer();
		searchcontainer.openSearchInput();
		// searchcontainer.initMobileSearchInput();
	} catch(e) {console.error(e);}
}
